import React, {Component} from "react";
import {withGoogleMap, GoogleMap, Polygon} from 'react-google-maps';
import CryptoJS from "crypto-js";
import Assignment from "@material-ui/icons/Assignment";
import GridContainer from "components/Grid/GridContainer.jsx";
//import Table from "components/Table/Table.jsx";
import Card from "components/Card/Card.jsx";
import ReactTable from "react-table";
import CardBody from "components/Card/CardBody.jsx";
import { PulseLoader } from "react-spinners";
import API from "@aws-amplify/api";
import withStyles from "@material-ui/core/styles/withStyles";
import userProfileStyles from "assets/jss/material-dashboard-pro-react/views/userProfileStyles.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Cookies from "universal-cookie";
import Tooltip from '@material-ui/core/Tooltip';
import Button from "components/CustomButtons/Button.jsx";
import Snackbar from "components/Snackbar/Snackbar.jsx";
import NavPills from "components/NavPills/NavPills.jsx";
import LoadingOverlay from "react-loading-overlay";
import { css } from "react-emotion";
import "assets/scss/styles.css";

let apiName = process.env.REACT_APP_AMPLIFY_API;
let geo = {
    "type": "FeatureCollection",
    "features": [
    {
    "type": "Feature",
    "properties": {
    "name": "Store 201 Trade Area",
    "color": "green"
    },
    "geometry": {
    "type": "Polygon",
    "coordinates": [
    [
    [
    -104.9310548,
    39.899410547
    ],
    [
    -104.8583521,
    39.931594893
    ],
    [
    -104.8274092,
    39.892850295
    ],
    [
    -104.8483301,
    39.82382951
    ],
    [
    -104.8630508,
    39.770307732
    ],
    [
    -104.8080686,
    39.774906113
    ],
    [
    -104.8155773,
    39.747514837
    ],
    [
    -104.783639,
    39.728981063
    ],
    [
    -104.7616209,
    39.696975581
    ],
    [
    -104.7553561,
    39.666997013
    ],
    [
    -104.7521204,
    39.625258028
    ],
    [
    -104.7823267,
    39.606023593
    ],
    [
    -104.8152533,
    39.576800292
    ],
    [
    -104.8130346,
    39.502602987
    ],
    [
    -104.8731447,
    39.482143505
    ],
    [
    -104.9289534,
    39.507186516
    ],
    [
    -104.9758129,
    39.576387552
    ],
    [
    -105.0241923,
    39.547125394
    ],
    [
    -105.0306182,
    39.609526803
    ],
    [
    -105.0903466,
    39.59637035
    ],
    [
    -105.2185508,
    39.554579936
    ],
    [
    -105.1901696,
    39.621512551
    ],
    [
    -105.2449677,
    39.652111912
    ],
    [
    -105.272126,
    39.694955717
    ],
    [
    -105.14692,
    39.733813863
    ],
    [
    -105.1705794,
    39.767496
    ],
    [
    -105.1443441,
    39.79624584
    ],
    [
    -105.1337908,
    39.82551043
    ],
    [
    -105.1544221,
    39.908855516
    ],
    [
    -105.1443392,
    39.979521192
    ],
    [
    -105.0513694,
    39.931707982
    ],
    [
    -104.9977644,
    39.957980379
    ],
    [
    -104.9310548,
    39.899410547
    ]
    ]
    ]
    }
    },
    {
    "type": "Feature",
    "properties": {
    "name": "Store 202 Trade Area",
    "color": "red"
    },
    "geometry": {
    "type": "Polygon",
    "coordinates": [
    [
    [
    -104.9419924,
    40.243511808
    ],
    [
    -104.8617081,
    40.214230133
    ],
    [
    -104.8594881,
    40.088240737
    ],
    [
    -104.7798345,
    40.085410744
    ],
    [
    -104.7810785,
    40.023112059
    ],
    [
    -104.6371347,
    40.03402878
    ],
    [
    -104.7481506,
    39.956137676
    ],
    [
    -104.8146604,
    39.916389508
    ],
    [
    -104.7884312,
    39.884378871
    ],
    [
    -104.8353171,
    39.861670338
    ],
    [
    -104.8348326,
    39.827204862
    ],
    [
    -104.8165467,
    39.753950642
    ],
    [
    -104.8255624,
    39.68894898
    ],
    [
    -104.8625895,
    39.625141396
    ],
    [
    -104.9496142,
    39.673377056
    ],
    [
    -105.0034547,
    39.665458998
    ],
    [
    -105.0631066,
    39.688459883
    ],
    [
    -105.1083908,
    39.711247159
    ],
    [
    -105.1707323,
    39.713044558
    ],
    [
    -105.173828,
    39.776461973
    ],
    [
    -105.1653696,
    39.826479983
    ],
    [
    -105.1373638,
    39.869393635
    ],
    [
    -105.1518729,
    39.890200704
    ],
    [
    -105.1805888,
    39.919313735
    ],
    [
    -105.1377832,
    39.943356833
    ],
    [
    -105.2108802,
    39.998586096
    ],
    [
    -105.1541529,
    40.011062163
    ],
    [
    -105.1638846,
    40.078117784
    ],
    [
    -105.0827836,
    40.06081869
    ],
    [
    -105.0858775,
    40.201822016
    ],
    [
    -104.9419924,
    40.243511808
    ]
    ]
    ]
    }
    }
    ]
    }
class ViewMaps extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }
  renderRegions(){
      return(
          <Polygon>
              path={geo}
              options={{
                  strokeColor: '#fc1e0d',
                  strokeOpacity: 1,
                  strokeWeight: 2,
                  icons:[{
                      icon: "hello",
                      offset: "0",
                      repeat: "10px"
                  }],
              }}
          </Polygon>
      )
  }
  render() {
      const GoogleMapExample =  withGoogleMap(props => (
          <GoogleMap
          defaultCenter = {{lng: -104.986248, lat: 39.913463}}
          defaultZoom = {8}
          >
              {this.renderRegions()}
          </GoogleMap>
      ))
      return(
          {GoogleMapExample}
      )
    }
}
export default withStyles(userProfileStyles)(ViewMaps);


// WEBPACK FOOTER //
// ./src/views/Maps/ViewMaps.jsx